import { useTranslation } from "react-i18next"
import Breadcrumb from "../../../components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar"
import AddRole from "src/components/panel/roles/AddRole"

const AddRolesView=()=>{
    const {t}=useTranslation()
   return (
     <>
       <Sidebar>
         <Breadcrumb
           title={t("add_roles_popup_title")}
           subtitle={t("add_role_description")}
         />

         <AddRole />
       </Sidebar>
     </>
   );
}
export default AddRolesView